/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

export const encodeContent = (str: string) => {
  return str.split('').map((c) => {
    if (/^[A-Za-z0-9 `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]*$/.test(c)) {
      return c
    }
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16).toUpperCase()).slice(-4);
  }).join('').replace(/[&<>'"]/g, 
  tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] as string));
}

export const decodeConent = (str: string) => {
  return str.replace(/\\u[\dA-F]{4}/gi, 
    (match) => {
          return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    });
}

export const decodeHtml = (html: string) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = decodeConent(html);
  return txt.value;
}

export const decodeHtmlContent = (html: string) => {
  const htmlCode = decodeHtml(html);
  return htmlCode.replace(/<h[^>].*?<\/h[^>]./ig,'').replace(/<[^>]*>?/gm, '');
}